import { render, staticRenderFns } from "./TableRole.vue?vue&type=template&id=acdfec36&"
import script from "./TableRole.vue?vue&type=script&lang=ts&"
export * from "./TableRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acdfec36')) {
      api.createRecord('acdfec36', component.options)
    } else {
      api.reload('acdfec36', component.options)
    }
    module.hot.accept("./TableRole.vue?vue&type=template&id=acdfec36&", function () {
      api.rerender('acdfec36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-management/components/user/TableRole.vue"
export default component.exports